import React from 'react';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const NoData = () => {
  return (
    <div className="flex flex-col space-y-3 justify-center h-full w-full text-center">
      <div>
        <img
          src={'assets/images/no-data.png'}
          alt="no data "
          className=" w-20 m-auto grayscale  "
        />
        <div className=" text-lg text-textSecondary text-center font-bold">
          <ReturnTranslatedText
            origintext="No Data"
            text={`general.${'No Data'}`}
          />
        </div>
      </div>
    </div>
  );
};

export default NoData;
